import { type UseQueryResult, useQuery } from 'react-query';
import { PrimaryStockExchangeService } from '../../services/wealthlane-customer-services';

const useGetPrimaryStockExchange = (
  handleRequest: <T>(request: Promise<T>) => Promise<T | undefined>
): UseQueryResult<
  | Array<{
      label: string;
      value: string;
    }>
  | undefined,
  unknown
> => {
  const primaryStockExchange = useQuery(
    ['getPrimaryStockExchange'],
    async () => {
      return await handleRequest(
        PrimaryStockExchangeService.getApiCustomerApiAppPrimaryStockExchangePrimaryStockExchangeList()
      );
    },
    {
      select: (data) => {
        return data?.map((item) => {
          return {
            label: item.name ?? '',
            value: item.id ?? '',
          };
        });
      },
    }
  );

  return primaryStockExchange;
};

export default useGetPrimaryStockExchange;
